<template>
  <label class="switch">
    <input
      :class="classes"
      type="checkbox"
      :checked="value ? 'checked' : ''"
      :name="name"
      :disabled="disabled"
      v-model="checked"
    />
    <span><slot></slot></span>
  </label>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    classes: String,
    value: Boolean,
    name: String,
  },
  data() {
    return {
      checked: null,
    };
  },
  beforeMount() {
    this.checked = this.value;
  },
  mounted() {
    this.$emit('input', this.checked);
  },
  watch: {
    checked(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.checked = val;
    },
  },
};
</script>

<style scoped>
label.switch input[type='checkbox'] {
  display: none;
}
label.switch input[type='checkbox']:checked + span:before {
  background-color: rgba(138, 138, 138, 0.5);
}
label.switch input[type='checkbox']:checked + span:after {
  background-color: #00eb5a;
  transform: translate(80%, -50%);
}
label.switch input[type='checkbox'] + span {
  top: -5px;
  position: relative;
  display: inline-block;
  cursor: pointer;
  font-weight: 500;
  text-align: left;
  margin: 0px;
  padding: 0px 44px;
}
label.switch input[type='checkbox'] + span:before,
label.switch input[type='checkbox'] + span:after {
  content: '';
  cursor: pointer;
  position: absolute;
  margin: 0;
  outline: 0;
  top: 50%;
  transform: translate(0, -50%);
  transition: all 200ms ease-out;
}
label.switch input[type='checkbox'] + span:before {
  left: -4px;
  width: 60px;
  height: 30px;
  background-color: rgba(126, 126, 126, 0.2);
  border-radius: 20px;
}
label.switch input[type='checkbox'] + span:after {
  left: 0;
  width: 30px;
  height: 30px;
  background-color: rgba(184, 184, 184, 0.5);
  border-radius: 50%;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);
}
label.switch input[type='checkbox']:checked + span label.switch input[type='checkbox']:after {
  transform: translate(80%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/switch/switch.vue